import { FieldValueType } from "@safetyculture/s12-apis-connect-web/s12/typefield/v1/field_pb";

export const mapFieldDataType = (fieldType: FieldValueType) => {
  switch (fieldType) {
    case FieldValueType.MONEY:
      return "Money";
    case FieldValueType.SELECT:
      return "Multi-select";
    case FieldValueType.USER_ID:
      return "User";
    case FieldValueType.STRING:
      return "Text";
    case FieldValueType.TIMESTAMP:
      return "Date";
    case FieldValueType.TEMPLATE_ID:
      return "Template";
    default:
      return "Unspecified";
  }
};
